'use client'

import { GetServerSidePropsContext, GetServerSidePropsResult } from "next";
import React from "react";

import { Config, StreamCredentials, getConfiguration, setBaseUrl } from "../lib/vertex/vertexConfig";
import { VertexApiLib } from "@/lib/vertex/api";
import CatalogDemo from "@/components/catalog/CatalogDemo";
import { SceneData } from "@vertexvis/api-client-node";

export interface Props {
  readonly config: Config;
  readonly streamCredentials?: StreamCredentials;
  readonly baseUrl: string;
  readonly catalogId: string;
}

import dynamic from 'next/dynamic'

const NoSSRComponent = dynamic(() => import('../components/artech/ARTechDemo'), { ssr: false })

export default function Index({...props}:Props): JSX.Element {
  return <NoSSRComponent {...props} />;
}

export async function getServerSideProps(
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<Props>> {
  const config = getConfiguration();
  const host = context.req.headers.host;
  const baseUrl = `http${host!.startsWith("localhost") ? "" : "s"}://${host}`;
  setBaseUrl(baseUrl);
  if (!host) return { props: { config, baseUrl, catalogId: ''} };

  const defaultCatalog = config.defaultCatalog;
  if (defaultCatalog == null) {
    throw new Error(`Default catalog value not found. Check or set environment variable VERTEX_DEFAULT_CATALOG.`);
  }
  const catalogId = /*context.query && context.query.catalog ? context.query.catalog.toString() :*/ defaultCatalog;
  const catalogSuppliedId = `CATALOG:${catalogId}`;
  // const sceneResult = await VertexApiLib.scenes.fetchSceneBySuppliedId(catalogSuppliedId);
  // if (sceneResult == null) {
  //   throw new Error(`Scene not found for catalog. Unable to fetch scene with supplied ID: ${catalogSuppliedId}`);
  // }
  // const scene: SceneData = sceneResult;

  // // trigger fetch catalog items
  // const catalogItems = await fetchCatalogItems(defaultCatalog);

  // create stream key
  // const res = await VertexApiLib.streamKeys.createStreamKey({ sceneId: scene.id });
  return {
    props: {
      baseUrl,
      config,
      streamCredentials: {
        clientId: config.credentials?.clientId ?? '',
        // sceneId: scene.id,
        // streamKey: res ?? '',
        // sceneViewSuppliedId: catalogSuppliedId
      },
      catalogId,
    }
  };
}
